import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-vaccinatie',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVaccinatie {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M35.7 4.59 31.41.3c-.4-.4-1.04-.4-1.43 0-.4.4-.4 1.04 0 1.43l1.43 1.43-4.3 4.3L25.65 6c-.78-.78-2.04-.77-2.81 0l-.02.02L7.96 20.84c-.28.28-.38.7-.23 1.07.35.9 1.07 2.29 1.83 3.1-.01.01-.03.01-.04.02L.3 34.27c-.4.4-.4 1.04 0 1.43.4.4 1.04.4 1.43 0l9.22-9.22s.03-.04.04-.06c.94.89 2.31 1.51 3.1 1.81.37.14.79.05 1.07-.23l14.79-14.79.04-.04c.78-.78.78-2.04 0-2.82L28.54 8.9l4.3-4.3 1.43 1.43c.4.4 1.04.4 1.43 0s.4-1.04 0-1.43Zm-7.16 7.16-6.02 6.02h-8.41l2.97-3.15 1.43 1.43c.4.4 1.04.4 1.43 0 .4-.4.4-1.04 0-1.43l-1.43-1.43 2.15-2.15 1.43 1.43c.4.4 1.04.4 1.43 0 .4-.4.4-1.04 0-1.43l-1.43-1.43 2.15-2.15 4.3 4.3Z"/>
</svg>

    );
  }
}
